import { STORE_CITY_DETAIL_REQUESTED, storeCityDetail } from 'app/store/actions';
import { localeSelector } from 'app/store/selectors';
import { takeEvery, select, put } from 'redux-saga/effects';

function* onStoreCityDetailsRequested(action) {
    const locale = yield select(localeSelector);

    yield put(storeCityDetail(locale, action.cityDetails));
}

export function* storeCityDetailsRequestedWatcher() {
    yield takeEvery(STORE_CITY_DETAIL_REQUESTED, onStoreCityDetailsRequested);
}
